import DashboardOwn from "./Own";

export default DashboardOwn;
